module.exports = __webpack_public_path__ + "static/img/fish40.4856c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish40.png
// module id = iWR5
// module chunks = 0